import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiPhone, FiCalendar } from 'react-icons/fi';
import { SITE_CONFIG } from '../data/content';

const MobileCallBar = () => {
  const phoneLink = `tel:${SITE_CONFIG.phone.replace(/\s/g, '')}`;

  return (
    <motion.div 
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      className="fixed bottom-0 left-0 right-0 z-[60] lg:hidden bg-white/90 backdrop-blur-lg border-t border-gray-100 p-4 pb-6 shadow-[0_-10px_25px_-5px_rgba(0,0,0,0.1)]"
    >
      <div className="flex gap-3 max-w-md mx-auto">
        <a 
          href={phoneLink}
          className="flex-1 bg-gray-900 text-white flex items-center justify-center gap-3 py-4 rounded-2xl font-black text-lg active:scale-95 transition-transform"
        >
          <SafeIcon icon={FiPhone} className="text-teal-400" />
          Call Us
        </a>
        <a 
          href={SITE_CONFIG.bookingUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 bg-teal-600 text-white flex items-center justify-center gap-3 py-4 rounded-2xl font-black text-lg active:scale-95 transition-transform"
        >
          <SafeIcon icon={FiCalendar} />
          Book
        </a>
      </div>
    </motion.div>
  );
};

export default MobileCallBar;